import { Component, OnInit, Input } from '@angular/core';
import { IServiceCard } from '../../shared/data-provider.service';

@Component({
  selector: 'app-service-card',
  templateUrl: './service-card.component.html',
  styleUrls: ['./service-card.component.scss']
})
export class ServiceCardComponent implements OnInit {
  @Input('service') serviceCardData: IServiceCard | null; // | null --> workaround to avoid buggy warnings. See: https://github.com/angular/angular-cli/issues/2034
  public get service(): IServiceCard { // alias
    return this.serviceCardData;
  }

  private _indexInDisplay: number;
  public get indexInDisplay(): number {
    return this._indexInDisplay;
  }
  @Input('index')
  public set indexInDisplay(value: number) {
    this._indexInDisplay = value;
    this.delay = (value % 4) * 100 + 'ms';
  }

  delay: string;

  constructor() {
  }

  ngOnInit(): void {
  }
}



// WEBPACK FOOTER //
// C:/Projects/dod/companyintroduction/src/app/services/service-card/service-card.component.ts